angular.module("app").controller("SkinsAndProvidersPageController", [
    '$scope',
    'preloadedSkins',
    'preloadedProviders',
    'hiddenGamesService',
    'skinService',
    'errorHandler',
    'logger',
    'pagination',
    '$timeout',
    function ($scope, preloadedSkins, preloadedProviders, hiddenGamesService, skinService, errorHandler, logger, pagination, $timeout) {

        $scope.providersPagination = pagination.init(function () {
            $scope.getProvidersBySkin();
        });

        $scope.skinsPagination = pagination.init(function () {
            $scope.getSkinsByProvider(!!$scope.filterSkins.provider);
        });
        $scope.providers = [];
        $scope.providersPagination.totalItems = 0;
        $scope.skins = [];
        $scope.skinsPagination.totalItems = 0;

        $scope.filterProviders = {
            skin_ids: [],
            hidden: 0,
            include_games_count: true,
            include_blocked_countries: true
        };
        $scope.exportFilterProviders = angular.copy($scope.filterProviders);
        $scope.exportFilterProviders.skin_ids = "";
        $scope.providersIgnoreColumns = {
            '$$hashKey': true,
            'hidden': true,
            'id': true,
        };

        $scope.skinsIgnoreColumns = {
            '$$hashKey': true,
            'base_host': true,
            'changed_at': true,
            'created_at': true,
            'license': true,
            'license_id': true,
            'defaultLang': true,
            'release_folder_name': true,
            'new_mobile_release_folder_name': true,
            'new_web_release_folder_name': true,

            'server_name': true,
            'mobile_server_name': true,
            'new_mobile_server_name': true,
            'new_web_server_name': true,

            'languages': true,
            'authLogin': true,
            'authPass': true,
            'server': true,
            'for_config_test': true,
            'allow_mobile_configs': true
        };

        $scope.isDisabled = function (p) {
            return p.totalItems == 0 ? 'disabled' : '';
        };

        function getPaginationFilter(p) {
            return {
                limit: p.limit,
                current_page: p.page
            }
        }

        $scope.filterSkins = {
            provider: null,
            gameId: null
        };
        var skinNameIdMap = {};
        $scope.skinTitles = angular.copy(preloadedSkins).map(function (item) {
            var name = "ID:" + item.id + " " + item.name;
            skinNameIdMap[name] = item.id;
            return name;
        });
        $scope.skinList = angular.copy(preloadedSkins);
        $scope.providerList = angular.copy(preloadedProviders);
        $scope.getProvidersBySkin = function (i) {
            if (!!$scope.filterProviders.skin_ids.length > 0) {
                var filterProviders =  angular.copy($scope.filterProviders);
                filterProviders.skin_ids = filterProviders.skin_ids.map(function (value) { return skinNameIdMap[value]; });
                $scope.exportFilterProviders.skin_ids = filterProviders.skin_ids.join(",");
                var requestData = angular.extend({}, filterProviders, getPaginationFilter($scope.providersPagination));
                return hiddenGamesService.getProvidersBySkinIds(requestData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.providers = angular.copy(response.items.map(function (value) {
                                value.hidden = !value.hidden;
                                value.blocked_countries =  value.blocked_countries.reduce(function (prev, curr) {
                                    if (prev === "") {
                                        return prev + curr;
                                    } else {
                                        return prev + ", " + curr;
                                    }
                                }, "");
                                return value
                            }));
                            $scope.providersPagination.totalItems = parseInt(response.total_count);
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                );
            }
            else {
                $scope.providers = [];
                $scope.providersPagination.totalItems = 0;
            }
        };

        $scope.getSkinsByProvider = function (isProviderChanged) {
            if (isProviderChanged) {
                if ($scope.filterSkins.gameId) {
                    $scope.filterSkins.gameId = null;
                    $scope.skinsPagination.page = 1;
                }
                $scope.searchTerm = "";
                $scope.notCallSearch = true;
            } else if ($scope.filterSkins.provider) {
                $scope.filterSkins.provider = null;
                $scope.skinsPagination.page = 1;
            }
            if (!!$scope.filterSkins.provider || !!$scope.filterSkins.gameId) {
                var request = {}
                var method;
                if ($scope.filterSkins.provider) {
                    request.provider = $scope.filterSkins.provider;
                    method = skinService.getSkinsByProvider;
                } else {
                    request.game_id = $scope.filterSkins.gameId;
                    method = skinService.getSkinsByGame;
                }
                var requestData = angular.extend({}, request, getPaginationFilter($scope.skinsPagination));
                return method(requestData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.skins = angular.copy(response.items);
                            $scope.skinsPagination.totalItems = parseInt(response.total_count);
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                );
            } else {
                $scope.skins = [];
                $scope.skinsPagination.totalItems = 0;
            }
        };

        $scope.providersListFilterObject = {
            action: function () {
                $scope.getProvidersBySkin();
            }
        };

        $scope.skinsListFilterObject = {
            action: function () {
                $scope.getSkinsByProvider();
            }
        };

        $scope.selectSkinGame = function selectSkinGame(gameId) {

            $scope.filterSkins.gameId = gameId;
            $scope.getSkinsByProvider();
        };
    }
]);
